import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import SydButton from '../../../commonDesign/Button'
import DateRangePicker from '../../../molecules/DateRangePicker'
const useStyles = makeStyles(() => ({
  modalBody: {
    maxHeight: '60vh',
    overflowY: 'auto',
    padding: '0 0 20px 0'
  },
  dateRangePickerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    justifyContent: 'flex-start'
  },
  buttonsContainer: {
    borderTop: '1px solid var(--color-neutral-200)',
    paddingTop: '20px',
    marginTop: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem'
  }
}))

const ColumnConfigurationDates = ({ onCancel, onSave, availableDates }) => {
  const classes = useStyles()
  const resetDates = () => {
    console.log('resetDates')
  }
  const [dates, setDates] = React.useState({
    startDate: null,
    endDate: null
  })
  return (
    <div className='flex flex-col justify-between gap-2 flex-1'>
      <div className={classes.modalBody}>
        <div className={classes.dateRangePickerContainer}>
          <DateRangePicker
            className={classes.dateRangePicker}
            variant='flex-start'
            startDateLabel='Start Date'
            defaultStartDate={availableDates.startDate}
            endDateLabel='End Date'
            defaultEndDate={availableDates.endDate}
            minDate={availableDates.startDate}
            maxDate={availableDates.endDate}
            onChange={(startDate, endDate) => {
              setDates({ startDate, endDate })
            }}
          />
        </div>
      </div>
      <div className={classes.buttonsContainer}>
        <div className='flex items-center'>
          <SydButton onClick={resetDates} variant='outline'>
            <span className='font-size-sm font-bold p-2'>Reset Dates</span>
          </SydButton>
        </div>
        <div className='flex items-center'>
          <SydButton onClick={onCancel} variant='outline'>
            <span className='font-size-sm font-bold p-2'>Cancel Changes</span>
          </SydButton>
        </div>
        <div className='flex items-center'>
          <SydButton
            onClick={() => {
              onSave(dates)
              onCancel()
            }}
            variant='primary'
            priority='main'
          >
            <span className='font-size-sm font-bold p-2'>Save Changes</span>
          </SydButton>
        </div>
      </div>
    </div>
  )
}

ColumnConfigurationDates.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  availableDates: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string
  })
}
ColumnConfigurationDates.defaultProps = {
  availableDates: {
    startDate: null,
    endDate: null
  }
}

export default ColumnConfigurationDates
